import { createSelector } from 'reselect';
import { prop } from 'ramda';
export const isModalWindowOpen = createSelector(
    prop('modalWindow'),
    (modalWindows) => (modalId) =>
        modalWindows && modalWindows[modalId] && modalWindows[modalId].show,
);
